module.exports = __webpack_public_path__ + "img/vipevent_group_icon@2x.7534063e.png";